<div class="container">
  <h2>Project Parameters</h2>
  <form [formGroup]="form" (ngSubmit)="save()">
    <!-- Project ID (read-only for edit mode) -->
    <div class="mb-3">
      <label>Project ID</label>
      <input formControlName="projectId" class="form-control" readonly />
    </div>

    <!-- Template -->
    <div class="mb-3">
      <label>Template</label>
      <select formControlName="templateId" class="form-select">
        <option *ngFor="let t of templates" [value]="t.MTShortCode">{{ t.MTShortCode }}</option>
      </select>
    </div>

    <!-- Layouts as checkbox list -->
    <div class="mb-3">
      <label class="form-label">Layouts</label>
      <div class="form-check" *ngFor="let l of layouts">
        <input
          class="form-check-input"
          type="checkbox"
          [value]="l.LayoutShortCode"
          (change)="onLayoutChange($event)"
          [checked]="form.value.layoutIds.includes(l.LayoutShortCode)"
        />
        <label class="form-check-label">{{ l.LayoutShortCode }}</label>
      </div>
    </div>

    <div class="mb-3">
      <label class="form-label">Default slide layout</label>
      <select class="form-select" formControlName="projectDefaultLayoutSC">
        <option value="">(first selected layout)</option>
        <option *ngFor="let code of form.value.layoutIds" [value]="code">{{ code }}</option>
      </select>
      <div class="form-text">
        Used as <code>slideLayoutSC</code> when TOC is pulled into this project. Falls back to the first ticked layout if blank.
      </div>
    </div>

    <!-- Custom Fields -->
    <div class="mb-3">
      <label>Custom Fields</label>
      <div formArrayName="customFields">
        <div *ngFor="let field of customFields.controls; let i = index" [formGroupName]="i" class="row mb-2">
          <div class="col">
            <input placeholder="Name" formControlName="name" class="form-control" />
          </div>
          <div class="col">
            <input placeholder="Value" formControlName="value" class="form-control" />
          </div>
          <div class="col-auto">
            <button type="button" class="btn btn-danger" (click)="removeCustomField(i)">X</button>
          </div>
        </div>
      </div>
      <button type="button" class="btn btn-secondary" (click)="addCustomField()">Add Field</button>
    </div>

    <hr />

    <!-- Audio settings -->
    <div class="mb-3">
      <label class="form-label">Audio Strategy</label>
      <select class="form-select" formControlName="projectAudioStrategy">
        <option value="SLIDE">Alternate options per slide</option>
        <option value="LINE">Rotate options per audio line</option>
      </select>
      <div class="form-text">
        AUDIO lines can override by setting `PSLAudioDirect` to an option key.
      </div>
    </div>

    <div class="mb-3">
      <label class="form-label">Break on newline (obsolete)</label>
      <select class="form-select" formControlName="projectBreakOnNewline" [disabled]="true">
        <option value="N">No longer used</option>
        <option value="Y">No longer used</option>
      </select>
      <div class="form-text">
        Text break is per slide-type / object-group line (Text break field). Seed always splits on newlines; soft-break by length uses line width when Text break is set.
      </div>
    </div>

    <div class="mb-3">
      <label class="form-label">Audio Options (Narakeet)</label>
      <div formArrayName="audioOptions">
        <div *ngFor="let opt of audioOptions.controls; let i = index" [formGroupName]="i" class="row g-2 align-items-end mb-2">
          <div class="col-md-2">
            <label class="form-label small">Key</label>
            <input class="form-control" formControlName="key" placeholder="opt1" />
          </div>
          <div class="col-md-2">
            <label class="form-label small">Language</label>
            <input class="form-control" formControlName="language" placeholder="e.g. EN, HI" />
          </div>
          <div class="col-md-3">
            <label class="form-label small">Voice</label>
            <input class="form-control" formControlName="voice" placeholder="e.g. mickey" />
          </div>
          <div class="col-md-2">
            <label class="form-label small">Voice speed</label>
            <input class="form-control" type="number" min="0.5" max="2" step="0.1" formControlName="voiceSpeed" />
          </div>
          <div class="col-md-2">
            <label class="form-label small">Voice volume</label>
            <select class="form-select" formControlName="voiceVolume">
              <option value="Standard">Standard</option>
              <option value="soft">soft</option>
              <option value="loud">loud</option>
            </select>
          </div>
          <div class="col-md-1">
            <button type="button" class="btn btn-danger w-100" (click)="removeAudioOption(i)">X</button>
          </div>
        </div>
      </div>
      <button type="button" class="btn btn-secondary" (click)="addAudioOption()">Add Audio Option</button>
    </div>

    <button type="submit" class="btn btn-primary">Save</button>
  </form>
</div>

